import { BehaviorSubject } from 'rxjs';
import { ModelAccountFromToken } from '../../models/authentication/account-from-token.model';
import { ModelOrganization } from '../../models/organizations/organization.model';

/*
This abstract class is used to wrap the authentication service so it can be mocked.
The commented private properties must be added to the file that implements the AbstractServiceAuthentication
*/
export abstract class AbstractAppAuthentication {


    /**
    * Returns a boolean indicating if the user is logged in.
    * @returns {boolean}
    * @remarks
    * REMEMBER TO UNSUBSCRIBE IF YOU SUBSCRIBE TO THIS PROPERTY
    * IF YOU DON'T NEED TO SUBSCRIBE JUST USE isLoggedIn.getValue()
    */
    abstract isLoggedIn: BehaviorSubject<boolean>;
    abstract get account(): ModelAccountFromToken | undefined;
    abstract get selectedOrganization(): ModelOrganization | undefined;
    abstract handleRedirectObservable(): void;
    abstract registerForAuthenticationEvents(): void;

    /*
    private updateLoginStatus(): void {
        this.loggedIn.next(!!this.authService.getAccount());
    }
    */

    abstract setRegisterAuthority(): void;

    abstract setLoginAuthority(): void;

    abstract logout(): void;
}
